import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_STARFISH_HOMEPAGE_V2_CONTENT = createFcmDetails('starfish_homepage_v2_content', {
	owner: 'starfish',
	context: 'Starfish Homepage V2 Content',
	description: 'Homepage V2 content for homepage relaunch. Includes impact section videos.',
	import: false,
	template: {
		isEnabled: true,
		impactVideos: [
			{
				title: 'Impact Video 1',
				url: 'video.mp4',
				ariaLabel: 'Impact Video 1',
				thumbnail: 'https://static.change.org/images/default-petition.gif',
			},
		],
	},
});
